<template>
  <div>
    <main-nav></main-nav>
  </div>
</template>

<script>
import MainNav from "@/components/home/MainNav.vue";

export default {
  name: "HomeView",
  components: {
    MainNav,
  }
};
</script>

<style scoped></style>